"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update_loan_application = exports.create_loan_application = void 0;
var firestore_1 = require("firebase/firestore");
var firebase_1 = require("../../../firebase");
var store_1 = require("../../../store");
var functions_1 = require("../../../constants/functions");
var lead_source_1 = require("../../../constants/lead_source");
var platform_1 = require("../../../constants/platform");
function create_loan_application(request) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return __awaiter(this, void 0, void 0, function () {
        var state, userState, userDocRef, providerRef, _m, branchRef, _o, loansCollectionRef, newLoanDocRef, newLoanDocSnapshot, loanData, error_1;
        return __generator(this, function (_p) {
            switch (_p.label) {
                case 0:
                    _p.trys.push([0, 11, , 12]);
                    state = store_1.redux_store.getState();
                    userState = state.userState;
                    return [4 /*yield*/, (0, firestore_1.doc)(firebase_1.firestore, "users", "".concat(userState.user.uid))];
                case 1:
                    userDocRef = _p.sent();
                    if (!request.provider) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, firestore_1.doc)(firebase_1.firestore, "providers", (_a = request.provider) !== null && _a !== void 0 ? _a : "")];
                case 2:
                    _m = _p.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _m = "";
                    _p.label = 4;
                case 4:
                    providerRef = _m;
                    if (!request.branch) return [3 /*break*/, 6];
                    return [4 /*yield*/, (0, firestore_1.doc)(firebase_1.firestore, "branches", (_b = request.branch) !== null && _b !== void 0 ? _b : "")];
                case 5:
                    _o = _p.sent();
                    return [3 /*break*/, 7];
                case 6:
                    _o = "";
                    _p.label = 7;
                case 7:
                    branchRef = _o;
                    return [4 /*yield*/, (0, firestore_1.collection)(firebase_1.firestore, "loan_applications")];
                case 8:
                    loansCollectionRef = _p.sent();
                    return [4 /*yield*/, (0, firestore_1.addDoc)(loansCollectionRef, {
                            amount: parseFloat((_c = request === null || request === void 0 ? void 0 : request.amount) !== null && _c !== void 0 ? _c : "0"),
                            provider: providerRef !== null && providerRef !== void 0 ? providerRef : "",
                            branch: branchRef !== null && branchRef !== void 0 ? branchRef : "",
                            basket_id: (_d = request === null || request === void 0 ? void 0 : request.basket_id) !== null && _d !== void 0 ? _d : "",
                            date_started: new Date(),
                            code: Math.random().toString(36).substring(2, 10).toUpperCase(),
                            user: userDocRef,
                            status: (_e = request.status) !== null && _e !== void 0 ? _e : "DRAFT",
                            docs_complete: false,
                            employment_complete: false,
                            family_complete: false,
                            financial_complete: false,
                            friend_complete: false,
                            is_product: (_f = request.is_product) !== null && _f !== void 0 ? _f : false,
                            paypoint_complete: false,
                            personal_complete: false,
                            sumsub_complete: false,
                            agree_terms: (_g = request.agree_terms) !== null && _g !== void 0 ? _g : false,
                            authoriseBank_complete: false,
                            authoriseSalary_complete: false,
                            bankDetails_complete: false,
                            term: (_h = request.term) !== null && _h !== void 0 ? _h : "12 Months",
                            order_id: (_j = request === null || request === void 0 ? void 0 : request.order_id) !== null && _j !== void 0 ? _j : "",
                            order_number: (_k = request === null || request === void 0 ? void 0 : request.order_number) !== null && _k !== void 0 ? _k : "",
                            products: (_l = request === null || request === void 0 ? void 0 : request.products) !== null && _l !== void 0 ? _l : null,
                            sources: {
                                initiated: "web",
                            },
                            lead_source: {
                                initiated: lead_source_1.LEAD_SOURCE,
                            },
                            country: platform_1.PLATFORM_COUNTRY,
                        })];
                case 9:
                    newLoanDocRef = _p.sent();
                    return [4 /*yield*/, (0, firestore_1.getDoc)(newLoanDocRef)];
                case 10:
                    newLoanDocSnapshot = _p.sent();
                    if (newLoanDocSnapshot.exists()) {
                        loanData = newLoanDocSnapshot.data();
                        return [2 /*return*/, { success: true, message: "Loan Application Started", content: __assign({ uid: newLoanDocSnapshot === null || newLoanDocSnapshot === void 0 ? void 0 : newLoanDocSnapshot.id }, loanData) }];
                    }
                    else {
                        return [2 /*return*/, { success: false, message: "Failed to create loan application", content: null }];
                    }
                    return [3 /*break*/, 12];
                case 11:
                    error_1 = _p.sent();
                    return [2 /*return*/, { success: false, message: "An error occurred", content: null }];
                case 12: return [2 /*return*/];
            }
        });
    });
}
exports.create_loan_application = create_loan_application;
function update_loan_application(request) {
    var _a, _b, _c, _d, _e;
    return __awaiter(this, void 0, void 0, function () {
        var loanDocRef, updateData, _f, _g, _h, _j, _k, _l, docSnapshot, existing, currentSources, currentLeadSource, _m, _o, _p, loanDocSnapshot, loanData, error_2;
        return __generator(this, function (_q) {
            switch (_q.label) {
                case 0:
                    _q.trys.push([0, 17, , 18]);
                    return [4 /*yield*/, (0, firestore_1.doc)(firebase_1.firestore, "loan_applications", "".concat(request.uid))];
                case 1:
                    loanDocRef = _q.sent();
                    //remove null objects from reques
                    request = (0, functions_1.removeUndefinedProperties)(request);
                    updateData = {};
                    if (request.docs_complete)
                        updateData["docs_complete"] = request.docs_complete;
                    if (request.employment_complete)
                        updateData["employment_complete"] = request.employment_complete;
                    if (request.family_complete)
                        updateData["family_complete"] = request.family_complete;
                    if (request.financial_complete)
                        updateData["financial_complete"] = request.financial_complete;
                    if (request.friend_complete)
                        updateData["friend_complete"] = request.friend_complete;
                    if (request.bankDetails_complete)
                        updateData["bankDetails_complete"] = request.bankDetails_complete;
                    if (request.paypoint_complete)
                        updateData["paypoint_complete"] = request.paypoint_complete;
                    if (request.sumsub_complete)
                        updateData["sumsub_complete"] = request.sumsub_complete;
                    if (request.personal_complete)
                        updateData["personal_complete"] = request.personal_complete;
                    if (request.agree_terms)
                        updateData["agree_terms"] = request.agree_terms;
                    if (request.authoriseBank_complete)
                        updateData["authoriseBank_complete"] = request.authoriseBank_complete;
                    if (request.authoriseSalary_complete)
                        updateData["authoriseSalary_complete"] = request.authoriseSalary_complete;
                    if (request.spouse)
                        updateData["spouse"] = request.spouse;
                    if (request.home_address)
                        updateData["home_address"] = request.home_address;
                    if (request.postal_address)
                        updateData["postal_address"] = request.postal_address;
                    if (request.family_member)
                        updateData["family_member"] = request.family_member;
                    if (request.friend)
                        updateData["friend"] = request.friend;
                    if (request.employment_details)
                        updateData["employment_details"] = request.employment_details;
                    if (request.salary_bank_details)
                        updateData["salary_bank_details"] = request.salary_bank_details;
                    if (request.financial_detail)
                        updateData["financial_detail"] = request.financial_detail;
                    if (request.latest_payslip)
                        updateData["latest_payslip"] = request.latest_payslip;
                    if (request.bank_statements)
                        updateData["bank_statements"] = request.bank_statements;
                    if (request.copy_of_id)
                        updateData["copy_of_id"] = request.copy_of_id;
                    if (request.force_number)
                        updateData["force_number"] = request.force_number;
                    if (request.authoriseSalary_complete)
                        updateData["authoriseSalary_complete"] = request.authoriseSalary_complete;
                    if (request.bank_debit_signature)
                        updateData["bank_debit_signature"] = request.bank_debit_signature;
                    if (request.salary_deduction_signature)
                        updateData["salary_deduction_signature"] = request.salary_deduction_signature;
                    if (request.status)
                        updateData["status"] = request.status;
                    if (request.term)
                        updateData["term"] = request.term;
                    if (request.paypoint_details)
                        updateData["paypoint_details"] = request.paypoint_details;
                    if (!request.provider) return [3 /*break*/, 5];
                    _f = updateData;
                    _g = "provider";
                    if (!request.provider) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, firestore_1.doc)(firebase_1.firestore, "providers", (_a = request.provider) !== null && _a !== void 0 ? _a : "")];
                case 2:
                    _h = _q.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _h = "";
                    _q.label = 4;
                case 4:
                    _f[_g] = _h;
                    _q.label = 5;
                case 5:
                    if (!request.branch) return [3 /*break*/, 9];
                    _j = updateData;
                    _k = "branch";
                    if (!request.branch) return [3 /*break*/, 7];
                    return [4 /*yield*/, (0, firestore_1.doc)(firebase_1.firestore, "branches", (_b = request.branch) !== null && _b !== void 0 ? _b : "")];
                case 6:
                    _l = _q.sent();
                    return [3 /*break*/, 8];
                case 7:
                    _l = "";
                    _q.label = 8;
                case 8:
                    _j[_k] = _l;
                    _q.label = 9;
                case 9:
                    if (request.order_id)
                        updateData["order_id"] = request.order_id;
                    if (request.order_number)
                        updateData["order_number"] = request.order_number;
                    if (request.country)
                        updateData["country"] = request.country;
                    if (!(request.status === "AWAIT")) return [3 /*break*/, 11];
                    return [4 /*yield*/, (0, firestore_1.getDoc)(loanDocRef)];
                case 10:
                    docSnapshot = _q.sent();
                    existing = docSnapshot.exists() ? docSnapshot.data() : {};
                    currentSources = (_c = existing.sources) !== null && _c !== void 0 ? _c : {};
                    currentLeadSource = (_d = existing.lead_source) !== null && _d !== void 0 ? _d : {};
                    updateData.sources = __assign(__assign({}, currentSources), { updated: "web" });
                    updateData.lead_source = __assign(__assign({}, currentLeadSource), { updated: lead_source_1.LEAD_SOURCE });
                    _q.label = 11;
                case 11:
                    if (!request.salesAgreement) return [3 /*break*/, 15];
                    _m = updateData;
                    _o = "salesAgreement";
                    if (!request.salesAgreement) return [3 /*break*/, 13];
                    return [4 /*yield*/, (0, firestore_1.doc)(firebase_1.firestore, "deviceSalesAgreements", (_e = request.salesAgreement) !== null && _e !== void 0 ? _e : "")];
                case 12:
                    _p = _q.sent();
                    return [3 /*break*/, 14];
                case 13:
                    _p = "";
                    _q.label = 14;
                case 14:
                    _m[_o] = _p;
                    _q.label = 15;
                case 15:
                    // Update Firebase Doc
                    (0, firestore_1.updateDoc)(loanDocRef, updateData);
                    return [4 /*yield*/, (0, firestore_1.getDoc)(loanDocRef)];
                case 16:
                    loanDocSnapshot = _q.sent();
                    if (loanDocSnapshot.exists()) {
                        loanData = loanDocSnapshot.data();
                        return [2 /*return*/, { success: true, message: "Loan Application Updated", content: __assign({ uid: loanDocSnapshot === null || loanDocSnapshot === void 0 ? void 0 : loanDocSnapshot.id }, loanData) }];
                    }
                    else {
                        return [2 /*return*/, { success: false, message: "Failed to update loan application", content: null }];
                    }
                    return [3 /*break*/, 18];
                case 17:
                    error_2 = _q.sent();
                    return [2 /*return*/, { success: false, message: "An error occurred", content: null }];
                case 18: return [2 /*return*/];
            }
        });
    });
}
exports.update_loan_application = update_loan_application;
